interface EmptyStateProps {
  daysUntilFirstRide: number;
  eventHasStarted: boolean;
  /** Real-time clock state. 0 means "not mounted yet" — suppress day count to avoid SSR garbage. */
  nowMs: number;
}

export function EmptyState({ daysUntilFirstRide, eventHasStarted, nowMs }: EmptyStateProps) {
  // nowMs === 0 happens during SSR / first client render. The countdown value
  // is meaningless (FIRST_RIDE_UTC_MS - 0 ≈ 56 years). Fall back to neutral
  // copy until the post-mount effect populates nowMs.
  const clockReady = nowMs > 0;

  const heading = eventHasStarted
    ? 'No live rides right now'
    : clockReady && daysUntilFirstRide > 0
      ? `Ride Day starts in ${daysUntilFirstRide} ${daysUntilFirstRide === 1 ? 'day' : 'days'}`
      : 'Ride Day starts soon';

  const body = eventHasStarted
    ? 'Every ride has wrapped up. Check the timeline once the next ride day approaches.'
    : 'Rides will appear here as soon as they go live across the world. The first one rolls out from New Zealand.';

  return (
    <div className="rounded-2xl border border-stone-950/10 bg-white/70 px-6 py-12 text-center">
      <p className="text-sm font-semibold uppercase tracking-[0.18em] text-dgr-gold-hover">
        Live Tracker
      </p>
      <h3 className="mt-3 text-xl font-bold text-stone-950 md:text-2xl">{heading}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-stone-700">{body}</p>
    </div>
  );
}
